/** @file renameClipNodes: a clip with node names mapped (keys, flex parents, tracks, event nodes). */
import type { Clip, NodeKey } from '@zilo/pose3d-format/types/clip';

/** A copy of `clip` where every node name `n` with an entry in `nodeMap` becomes `nodeMap[n]`. */
export function renameClipNodes(clip: Clip, nodeMap: Readonly<Record<string, string>>): Clip {
  const to = (n: string): string => (Object.hasOwn(nodeMap, n) ? nodeMap[n] ?? n : n);
  const renameKey = (k: NodeKey): NodeKey => (typeof k.parent === 'string' ? { ...k, parent: to(k.parent) } : { ...k });
  const out = structuredClone(clip);
  out.keys = out.keys.map((key) => ({
    ...key,
    nodes: Object.fromEntries(Object.entries(key.nodes).map(([n, k]) => [to(n), renameKey(k)])),
    ...(key.events === undefined ? {} : { events: key.events.map((e) => (e.node === undefined ? e : { ...e, node: to(e.node) })) }),
  }));
  if (out.tracks !== undefined) out.tracks = Object.fromEntries(Object.entries(out.tracks).map(([n, t]) => [to(n), t]));
  return out;
}
